import { h, render } from "preact";
import App from "./Pages/App.jsx";
import "./styles/global.css";

render(<App />, document.getElementById("app"));